import React from 'react'

import { TextContentButton } from 'common/builder/components/chart/FlowChart/components/Block/components/TextContent/TextContentButton'
import {
  ContentPart,
  ContentPartType,
} from 'common/builder/components/chart/FlowChart/hooks/useTextContentParts'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

interface TextContentPartProps {
  contentPart: ContentPart
  buttons: FlowChartButton[]
}

export const TextContentPart = ({ contentPart: part, buttons }: TextContentPartProps) => {
  if (part.type === ContentPartType.BUTTON) {
    return <TextContentButton contentPart={part} buttons={buttons} />
  }

  if (part.type === ContentPartType.TEXT) {
    return <richtext style={sharedStyles.text} text={part.text} />
  }

  return null
}
